export default __webpack_public_path__ + "static/media/intro-marketing-digital.8b266357.svg";